export default __webpack_public_path__ + "assets/icons/packaged.87748940.svg";